export const checkAddressExistsInWhiteList = (
  data: string[],
  address: string,
) => {
  return data.map((el) => el.toLowerCase()).includes(address.toLowerCase());
};
